import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import UploaderAddBase from './UploaderAddBase';

import { isValidLink } from '../utils/link.utils';

const UploaderAddVideo = ({ onBack, onDone, onAdd, onDelete, media, isAdding }) => {
  return (
    <UploaderAddBase
      title={<FormattedMessage id="uploader.video_modal.title" defaultMessage="Add videos" />}
      description={
        <>
          <FormattedMessage id="uploader.video_modal.description" defaultMessage="Add videos to your listing gallery. We recommend showing a tour of your space." />
          {' '}
          <FormattedMessage id="uploader.embed.wait" defaultMessage="It may take up to 48 hours for your content to appear on your listings." />
        </>
      }
      linkTitle={<FormattedMessage id="uploader.video_modal.link_title" defaultMessage="YouTube or Vimeo" />}
      linkDescription={<FormattedMessage id="uploader.video_modal.link_description" defaultMessage="We accept Youtube and Vimeo links." />}
      alert={<FormattedMessage id="uploader.video_modal.alert" defaultMessage="Videos appear in your listing gallery, and clear labels will show in search results and on your listing page so guests know videos are available." />}
      onBack={onBack}
      onDone={onDone}
      onAdd={onAdd}
      onDelete={onDelete}
      onValidation={(link) => isValidLink(link, 'video')}
      media={media}
      isAdding={isAdding}
    />
  );
};

UploaderAddVideo.propTypes = {
  onBack: PropTypes.func,
  onDone: PropTypes.func,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  media: PropTypes.array,
  isAdding: PropTypes.bool
};

UploaderAddVideo.defaultProps = {
  onBack: () => {},
  onDone: () => {},
  onAdd: () => {},
  onDelete: () => {},
  media: [],
  isAdding: false
};

export default UploaderAddVideo;
